import { QUERY_NOT_FOUND_PAGE } from '@/graphql/queries/global/not-found';
import {
  NotFoundPage,
  NotFoundPageQuery,
  QueryFooterQuery,
  QueryMenuQuery,
  QueryTermsAndConditionsQuery,
} from '../../graphql/generated/graphql';

import { QUERY_FOOTER } from '../../graphql/queries/global/footer';
import { QUERY_MENU } from '../../graphql/queries/global/menu';
import { initializeApollo, initializeApolloWithoutToken } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import { QUERY_TERMS_AND_CONDITIONS } from '@/graphql/queries/global/terms-and-conditions';
import { RoutesEnum, isAuthorized } from '@/auth.guard';

export async function fetchMenu() {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<QueryMenuQuery>({
      query: QUERY_MENU,
      fetchPolicy: 'cache-first',
    }),
  );
  if (!data) return { menu: {}, error };

  const menuFiltered = data.globalMenu?.data?.attributes?.links?.filter((link) => {
    let route: RoutesEnum = RoutesEnum.DAILY_BUBBLE;
    switch (link?.url) {
      case '/':
        route = RoutesEnum.DAILY_BUBBLE;
        break;
      case '/knowledge-hub':
        route = RoutesEnum.KNOWLEDGE_HUB;
        break;
      case '/podcast':
        route = RoutesEnum.PODCAST;
        break;
      case '/learn':
        route = RoutesEnum.LEARN;
        break;
      case '/mindful-exercise':
        route = RoutesEnum.MEDITATION;
        break;
      case '/dashboard':
        route = RoutesEnum.REPORTING_DASHBOARD;
        break;
      case '/admin':
        route = RoutesEnum.ADMIN_MANAGEMENT;
        break;
    }
    return isAuthorized(route);
  });

  const menu = {
    ...{ ...data.globalMenu?.data?.attributes, links: menuFiltered },
    logo: {
      url: data.globalMenu?.data?.attributes?.logo?.data?.attributes?.url,
      alternativeText: data.globalMenu?.data?.attributes?.logo?.data?.attributes?.alternativeText,
    },
  };

  return {
    menu,
  };
}
export async function fetchFooter() {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<QueryFooterQuery>({
      query: QUERY_FOOTER,
      fetchPolicy: 'cache-first',
    }),
  );

  if (!data) return { footer: {}, error };

  const footer = {
    ...data.globalFooter?.data?.attributes,
  };

  return { footer };
}

export async function fetchNotFoundPage() {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<NotFoundPageQuery>({
      query: QUERY_NOT_FOUND_PAGE,
      fetchPolicy: 'cache-first',
    }),
  );

  if (!data) return { notFound: {} as NotFoundPage, error };

  const notFound = {
    ...(data.notFoundPage?.data?.attributes as NotFoundPage),
  };

  return { notFound, error };
}

export async function fetchTermsAndConditions() {
  const apolloClient = initializeApolloWithoutToken();

  const { data, error } = await requestHandler(
    apolloClient.query<QueryTermsAndConditionsQuery>({
      query: QUERY_TERMS_AND_CONDITIONS,
      fetchPolicy: 'cache-first',
    }),
  );

  if (!data) return { termsAndConditions: {}, error };

  const termsAndConditions = {
    ...data.termAndCondition?.data?.attributes,
  };

  return { termsAndConditions };
}
